<template>
  <label class="inline-block">
    <span v-if="$slots.default" class="text-black font-medium dark:text-white me-2">
     <slot/>
    </span>
    <span class="relative inline-block align-middle select-none">
        <input type="checkbox" name="toggle" v-model="computedValue" @input="onToggle" @click.stop
               :class="[{['text-'+color]: true},{'w-5 h-5': size === 'small'},
               {'w-7 h-7': size === 'medium'},{'rounded-full': rounded}]"/>
    </span>

  </label>
</template>

<script>
export default {
  name: 'ZCheckBox',
  props: {
    value: {
      type: Boolean
    },
    size: {
      // @values small/medium
      type: String,
      default: () => 'medium'
    },
    color: {
      type: String,
      default: () => 'secondary'
    },
    rounded: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    localValue: false,
    uuid: null
  }),
  methods: {
    onToggle(val) {
      this.$emit('input', val.target.checked)
    }
  },
  watch: {
    value(val) {
      this.localValue = val
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.localValue
      },
      set(val) {
        this.localValue = val
        this.$emit('input', val)
      }
    },
  },
  mounted() {
    this.localValue = this.value
  },
  beforeCreate: function () {
    this.uuid = Math.random().toString(36).substr(2, 12)
  }
}
</script>

<style scoped>

</style>
